import { useAuthStore } from '../store/auth'
import { createApolloClient } from './createApolloClient'

/**
 * The shopper embed's single Apollo client for Core (link chain in `createApolloClient`). The token
 * comes from the consumer auth store per request, and a "Not Authorised" error logs the consumer out.
 */
export const apolloClient = createApolloClient({
  getToken: () => useAuthStore.getState().token,
  onUnauthorised: () => useAuthStore.getState().logout(),
})
